import { CircleArrowUp } from "lucide-react";
import { RefObject } from "react";

import { IgButton } from "@intelligems/ig-theme/IgButton";
import { IgLink } from "@intelligems/ig-theme/IgLink";
import { Stack, useTheme } from "@mui/material";
import { VersionDisplay } from "@src/domains/Settings/VersionDisplay";
import { Logout } from "@src/utils";

import { SwitchToDesktop } from "../components/SwitchToDesktop";

type MobileFooterProps = {
  scrollRef?: RefObject<HTMLElement | null>;
};

function MobileFooter({ scrollRef }: MobileFooterProps) {
  const theme = useTheme();

  const handleBackToTop = () => {
    const target = scrollRef?.current ?? document.body;
    target.scrollTo({ top: 0, behavior: "smooth" });
  };

  const style = {
    paddingY: 4,
    marginY: 1,
    boxShadow: "none",
    "&:hover, &:focus": {
      boxShadow: "none",
    },
  };

  return (
    <Stack spacing={2} sx={{ p: 4, pb: 8 }}>
      <IgButton
        size="extraSmall"
        variant="text"
        fullWidth
        onClick={handleBackToTop}
        sx={{
          boxShadow: "none",
          "&:hover, &:focus": {
            boxShadow: "none",
          },
        }}
      >
        <Stack justifyContent="center" alignItems="center" spacing={1}>
          <CircleArrowUp color={theme.palette.text.accent} />
          <IgLink fontWeight={600}>Back to Top</IgLink>
        </Stack>
      </IgButton>

      <SwitchToDesktop sx={style} />

      <IgButton
        size="large"
        variant="outlined"
        fullWidth
        onClick={Logout}
        sx={style}
      >
        Log out
      </IgButton>
      <VersionDisplay
        sx={{
          paddingTop: 4,
        }}
      />
    </Stack>
  );
}

export default MobileFooter;
